/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TabPanel } from '@coursera/cds-core';

import EmptyCompletedCoursesMessage from 'bundles/degree-home/components/EmptyCompletedCoursesMessage';
import EndedCourses from 'bundles/degree-home/components/EndedCourses';
import InProgressCourses from 'bundles/degree-home/components/InProgressCourses';
import Loader from 'bundles/degree-home/components/Loader';
import NotStartedCourses from 'bundles/degree-home/components/NotStartedCourses';
import { PATHS } from 'bundles/degree-home/components/v3-dpm/constants/constants';

import { SummaryCard } from './SummaryCard';
import { useCoursesContext } from './v2/CoursesProvider';
import { useRedirectIfV3 } from './v3-dpm/lib/experiments';

const styles = {
  tabPanel: () => css`
    margin-top: var(--cds-spacing-400);
  `,
};

export const DegreeSummary = () => {
  useRedirectIfV3(PATHS.ACADEMICS);
  const {
    upcomingCoursesData: notStartedCourses,
    passedCoursesData: passedCourses,
    inProgressCoursesData: inProgressCourses,
    coursesLoading,
  } = useCoursesContext();
  const hasPassedCourses = passedCourses && passedCourses.length > 0;
  const hasInProgressCourses = inProgressCourses && inProgressCourses.length > 0;
  const hasNotStartedCourses = notStartedCourses && notStartedCourses.length > 0;
  const hasCourses = hasPassedCourses || hasInProgressCourses || hasNotStartedCourses;

  return (
    <TabPanel value="summary" data-e2e="degree-summary-tab-content" css={styles.tabPanel}>
      {hasInProgressCourses && <InProgressCourses loading={coursesLoading} inProgressCourses={inProgressCourses} />}
      {hasNotStartedCourses && <NotStartedCourses loading={coursesLoading} notStartedCourses={notStartedCourses} />}
      {hasPassedCourses && <EndedCourses loading={coursesLoading} passedCourses={passedCourses} />}

      {!hasCourses && (
        <SummaryCard>
          {coursesLoading && <Loader />}
          {!coursesLoading && <EmptyCompletedCoursesMessage />}
        </SummaryCard>
      )}
    </TabPanel>
  );
};

export default DegreeSummary;
